<template>
  <v-menu
    offset-y
    :top="variant === 'full'"
    :left="variant === 'compact'"
    min-width="244"
    nudge-bottom="6"
    >
    <template v-slot:activator="{ on, attrs }">
      <!-- full (sidebar bottom): avatar + email + agency -->
      <button
        v-if="variant === 'full'"
        type="button"
        class="usermenu__bar"
        v-on="on"
        v-bind="attrs"
        >
        <v-avatar size="34" color="accent">
          <span class="white--text font-weight-bold">{{ userInitial }}</span>
        </v-avatar>
        <div class="usermenu__id">
          <div class="usermenu__email">{{ currentUser.email }}</div>
          <div class="usermenu__agency">{{ currentUser.selectedAgency.name }}</div>
        </div>
        <hero-icon :icon="ChevronUpDownIcon" :size="18" class="usermenu__chev" />
      </button>

      <!-- compact (mobile app bar): icon avatar -->
      <v-btn v-else icon v-on="on" v-bind="attrs">
        <v-avatar size="36" color="accent">
          <span class="white--text font-weight-bold">{{ userInitial }}</span>
        </v-avatar>
      </v-btn>
    </template>

    <v-list dense class="usermenu__list">
      <div class="usermenu__head">
        <v-avatar size="36" color="accent" class="mr-3">
          <span class="white--text font-weight-bold">{{ userInitial }}</span>
        </v-avatar>
        <div class="usermenu__id">
          <div class="usermenu__email">{{ currentUser.email }}</div>
          <div class="usermenu__agency">{{ currentUser.selectedAgency.name }}</div>
        </div>
      </div>

      <v-divider></v-divider>

      <v-list-item :to="{ name: 'Settings' }">
        <v-list-item-icon class="usermenu__icon"><hero-icon :icon="CogIcon" :size="18" /></v-list-item-icon>
        <v-list-item-title>Preferencias</v-list-item-title>
      </v-list-item>

      <v-list-item @click="$emit('novedades')">
        <v-list-item-icon class="usermenu__icon"><hero-icon :icon="SparklesIcon" :size="18" /></v-list-item-icon>
        <v-list-item-title>Novedades</v-list-item-title>
      </v-list-item>

      <template v-if="otherAgencies.length">
        <v-divider></v-divider>
        <v-subheader class="usermenu__sub">Cambiar agencia</v-subheader>
        <v-list-item
          v-for="ua in otherAgencies"
          :key="ua.id"
          @click="changeSelectedAgency(ua.id)"
          >
          <v-list-item-title>{{ ua.agency.name }}</v-list-item-title>
        </v-list-item>
      </template>

      <v-divider></v-divider>

      <v-list-item @click="logout">
        <v-list-item-icon class="usermenu__icon"><hero-icon :icon="LogoutIcon" :size="18" /></v-list-item-icon>
        <v-list-item-title>Cerrar sesión</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import { SwitchSelectedAgency } from "@/graphql/mutations/user";
import { TokenService } from "@/services/storageService";
import HeroIcon from "@/components/shared/HeroIcon";
import CogIcon from "heroicons/24/outline/cog-6-tooth.svg";
import SparklesIcon from "heroicons/24/outline/sparkles.svg";
import LogoutIcon from "heroicons/24/outline/arrow-right-on-rectangle.svg";
import ChevronUpDownIcon from "heroicons/24/outline/chevron-up-down.svg";

export default {
  name: "UserMenu",

  components: { HeroIcon },

  props: {
    // 'compact' (icon, for the mobile app bar) | 'full' (row, for the sidebar bottom)
    variant: { type: String, default: "compact" }
  },

  data: () => ({ CogIcon, SparklesIcon, LogoutIcon, ChevronUpDownIcon }),

  computed: {
    ...mapGetters(["currentUser"]),

    userInitial() {
      const email = this.currentUser && this.currentUser.email;
      return email ? email.charAt(0).toUpperCase() : "?";
    },

    otherAgencies() {
      const list = (this.currentUser && this.currentUser.userAgencies) || [];
      return list.filter(a => !a.selected);
    }
  },

  methods: {
    logout() {
      TokenService.removeToken();
      this.$router.go("");
    },

    changeSelectedAgency(id) {
      this.$apollo
        .mutate({
          mutation: SwitchSelectedAgency,
          variables: { input: { id } }
        })
        .then(() => this.$router.go());
    }
  }
};
</script>

<style scoped>
.usermenu__bar {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 14px;
  border: none;
  border-top: 1px solid #ece7de;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;
}
.usermenu__bar:hover { background: #faf8f4; }
.usermenu__id { flex: 1; min-width: 0; }
.usermenu__email {
  font-size: 13px;
  font-weight: 600;
  color: #1a1814;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.usermenu__agency {
  font-size: 11.5px;
  color: #756f64;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.usermenu__chev { color: #a39a8c; flex: none; }

.usermenu__head { display: flex; align-items: center; padding: 12px 16px; }
.usermenu__list .hero-icon { color: #6a645a; }

/* tighten the icon→label gap (Vuetify defaults v-list-item__icon to 32px) */
.usermenu__list .usermenu__icon {
  min-width: 22px;
  margin: 0 14px 0 0;
  align-self: center;
}
</style>
